module.exports = __webpack_public_path__ + "img/TransferPage.b92e4ab0.png";